import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import hr from '../locales/hr.json';
import en from '../locales/en.json';
import de from '../locales/de.json';
import type { Language } from '../types';

const supported: Language[] = ['hr', 'en', 'de'];
const stored = localStorage.getItem('arborcad-language') as Language | null;
const detected = navigator.language.slice(0, 2) as Language;
const initial = stored && supported.includes(stored) ? stored : supported.includes(detected) ? detected : 'en';

void i18n.use(initReactI18next).init({
  resources: { hr: { translation: hr }, en: { translation: en }, de: { translation: de } },
  lng: initial,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

i18n.on('languageChanged', (language) => localStorage.setItem('arborcad-language', language));

export default i18n;
